export function normalizeHTML(input: string) {
	// Trim whitespace and remove all line breaks to avoid inconsistent formatting
	const trimmed = input.trim().replace(/\n+/g, '');

	// If there's no <p> tag at all, we treat it as raw input that needs formatting
	if (!/<\/?p>/i.test(trimmed)) {
		const lines = trimmed.split(/<br\s*\/?>/i).map(line => {
			const trimmedLine = line.trim();
			// Wrap each non-empty line with <p>, or insert <p><br /></p> for empty lines
			return trimmedLine ? `<p>${trimmedLine}</p>` : `<p><br /></p>`;
		});
		return lines.join('\n');
	}

	// Extract all paragraph blocks from the input
	const paragraphBlocks = trimmed.match(/<p[\s\S]*?<\/p>/gi) || [];

	const result = paragraphBlocks.flatMap(block => {
		// Remove the opening and closing <p> tags to access the inner content
		const inner = block.replace(/^<p>/i, '').replace(/<\/p>$/i, '');

		// If the paragraph only contains a <br>, keep it as a single line break
		if (/^<br\s*\/?>$/i.test(inner.trim())) {
			return [`<p><br /></p>`];
		}

		// If there are no <br> tags, it's already a simple paragraph — keep as-is
		if (!/<br\s*\/?>/i.test(inner)) {
			return [`<p>${inner.trim()}</p>`];
		}

		// Otherwise, split by <br> and convert each segment into a <p>
		return inner.split(/<br\s*\/?>/i).map(line => {
			const trimmedLine = line.trim();
			// Again, wrap text or insert a blank paragraph for empty lines
			return trimmedLine ? `<p>${trimmedLine}</p>` : `<p><br /></p>`;
		});
	});

	// Return the final normalized HTML
	return result.join('\n');
}
